import { ACCOUNT_STORAGE_KEYS } from "./storage";

const getStorage = () => {
  try {
    if (typeof window === "undefined") {
      return null;
    }

    return window.localStorage;
  } catch {
    return null;
  }
};

const readToken = (key, errorMessage) => {
  try {
    return getStorage()?.getItem(key) || null;
  } catch (error) {
    console.error(errorMessage, error);
    return null;
  }
};

export const getAccessToken = () =>
  readToken(ACCOUNT_STORAGE_KEYS.accessToken, "Failed to get access token:");

export const getRefreshToken = () =>
  readToken(ACCOUNT_STORAGE_KEYS.refreshToken, "Failed to get refresh token:");

export const setTokens = (accessToken, refreshToken) => {
  try {
    const storage = getStorage();

    if (!storage) {
      return;
    }

    if (accessToken) {
      storage.setItem(ACCOUNT_STORAGE_KEYS.accessToken, accessToken);
    }

    if (refreshToken) {
      storage.setItem(ACCOUNT_STORAGE_KEYS.refreshToken, refreshToken);
    }
  } catch (error) {
    console.error("Failed to set tokens:", error);
  }
};

export const clearTokens = () => {
  try {
    const storage = getStorage();

    if (!storage) {
      return;
    }

    storage.removeItem(ACCOUNT_STORAGE_KEYS.accessToken);
    storage.removeItem(ACCOUNT_STORAGE_KEYS.refreshToken);
  } catch (error) {
    console.error("Failed to clear tokens:", error);
  }
};

export const getAuthErrorMessage = (
  error,
  fallback = "Authentication failed",
) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

export const parseAuthCallbackParams = (search = "") => {
  const params = new URLSearchParams(search);
  const openidParams = {};
  let nextPath = null;

  for (const [key, value] of params.entries()) {
    if (key.startsWith("openid.")) {
      openidParams[key] = value;
    } else if (key === "next") {
      nextPath = decodeURIComponent(value);
    }
  }

  return {
    openidParams,
    nextPath,
    hasOpenIdCallback: Object.keys(openidParams).length > 0,
  };
};

export const buildAuthUrlWithNext = (authUrl, nextPath) => {
  if (!nextPath) {
    return authUrl;
  }

  try {
    const base =
      typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost";
    const url = new URL(authUrl, base);
    url.searchParams.set("next", encodeURIComponent(nextPath));
    return url.toString();
  } catch {
    return authUrl;
  }
};
